import Style from "./CreateAdminStyle";
import api from "../../services/api";
import { useState, useEffect } from "react";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import PageTitle from "../../components/PageTitle";

interface company {
  id: number,
  name: string,
  accountId: number,
  logoUrl: string
}
export default function CreateAdmin(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [job, setJob] = useState("");
  const [company, setCompany] = useState("");
  const [companies, setCompanies] = useState<company[]>([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [successMessage, setSuccessMessage] = useState<string>();
  const [showPopup, setShowPopup] = useState(false);



  useEffect(() => {
    LoadCompany();
  }, []);

  async function LoadCompany() {
    try {
      const result = await api.get(`/companies/all`);
      if (result.data.companies.length > 0) {
        setCompanies(result.data.companies);
        setCompany(result.data.companies[0].name);
      }
      setLoading(false)
    } catch (error) {
      console.error("Erro ao buscar o admin selecionado: ", error);
      setLoading(false)
    }
  }


  function OnSubmit() {
    onCreate()
  }

  async function onCreate() {
    try {
      setLoading(true);
      const data = {
        name, email: email.toLowerCase(), password, job, company, acceptedLGPD: true,
      }
      const request = api.post(`/admin/create`, data);
      await request;
      setSuccessMessage("Conta de admin nome: " + name + ", para empresa: " + company + ", criado com sucesso!");
      onClosePopup();
      setLoading(false);
    }
    catch (error: any) {
      setLoading(false);
      onClosePopup();
      setErrorMessage(error?.response?.data?.message);
    }
  }


  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  return (
    <Style>
      <PageTitle title="Criar Admin" />
      <div>
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopup}
          loading={loading}
          title="Deleção de admin!"
          body={"Você tem certeza que deseja cadastrar este admin?"}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={() => OnSubmit()}
          primaryDisabled={loading}
        />

        <div>
          <button onClick={() => props.history.goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-danger">Erro: {errorMessage}</p>}
        {successMessage && <p className="alert alert-info">{successMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
              <h2>Cadastro de administradores</h2>
              <div>
                <label>Empresa:</label>
                <select name="company"
                  id="company"
                  value={company}
                  onChange={e => setCompany(e.target.value)}>
                  {companies.length > 0 && companies.map(c =>
                    <option key={c.id} value={c.name}>{c.name}</option>
                  )}
                </select>
              </div>
              <div>
                <label>Nome:</label>
                <input
                  disabled={loading}
                  defaultValue={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Email:</label>
                <input
                  disabled={loading}
                  value={email || ""}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label>Senha:</label>
                <input
                  type="password"
                  disabled={loading}
                  value={password || ""}
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label>Cargo:</label>
                <input
                  disabled={loading}
                  value={job || ""}
                  onChange={e => setJob(e.target.value)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>Adicionar</button>
            </form>
          </div>
        </main>
      </div>
    </Style >
  );
}